import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=37dc169c&scoped=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"
import style0 from "./Container.vue?vue&type=style&index=0&id=37dc169c&prod&lang=scss"
import style1 from "./Container.vue?vue&type=style&index=1&id=37dc169c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc169c",
  null
  
)

export default component.exports